// Шапка полноэкранного раздела: назад + заголовок + правый слот.
// Заменяет продублированный .analytics-header в Analytics/Limits/Health.

import type { ReactNode } from 'react';
import { haptic } from '../lib/telegram';
import { ChevronLeftIcon } from './icons';

type Props = {
  title: string;
  onBack?: () => void;
  right?: ReactNode;
};

export function ScreenHeader({ title, onBack, right }: Props): JSX.Element {
  return (
    <div className="screen-header">
      {onBack ? (
        <button
          type="button"
          className="screen-back"
          onClick={() => {
            haptic('light');
            onBack();
          }}
          aria-label="Назад"
        >
          <ChevronLeftIcon />
        </button>
      ) : null}
      <h2 className="screen-header-title">{title}</h2>
      {right ? <div className="screen-header-right">{right}</div> : null}
    </div>
  );
}
